import styled from "@emotion/styled";
import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import { isDefined, IsDefined } from "./IsDefined";

interface Props {
  className?: string;
  bordered?: boolean;
  density?: "default" | "densed" | "unset";
}

export function AppList(props: PropsWithChildren<Props>): ReactElement {
  const density = props.density !== undefined ? props.density : "default";

  return (
    <div
      data-density={density}
      className={classNames("AppList", props.className, {
        Bordered: props.bordered === true,
      })}
    >
      {props.children}
    </div>
  );
}

export interface AppListItemProps {
  leading?: React.ReactNode;
  title: React.ReactNode;
  trailing?: React.ReactNode;
  extra?: React.ReactNode;
  soft?: boolean;
  className?: string;
  bulletNumber?: number;
  bordered?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
  onClickTitle?: () => void;
}

export function AppListItem(props: AppListItemProps): ReactElement {
  return (
    <div
      onClick={props.onClick}
      style={props.style}
      className={classNames("AppListItem", props.className, {
        Soft: props.soft === true,
      })}
    >
      <IsDefined value={getAppListItemLeading(props)}>
        {(leading) => <div className="leading">{leading}</div>}
      </IsDefined>

      <div className="title" onClick={props.onClickTitle}>
        {props.title}
      </div>

      <IsDefined value={props.trailing}>
        {(trailing) => <div className="trailing">{trailing}</div>}
      </IsDefined>

      <IsDefined value={props.extra}>{(extra) => <div className="extra">{extra}</div>}</IsDefined>
    </div>
  );
}

const getAppListItemLeading = ({ leading, bulletNumber }: AppListItemProps) => {
  if (isDefined(leading)) {
    return leading;
  }

  if (isDefined(bulletNumber)) {
    return <ListItemBullet>{bulletNumber}</ListItemBullet>;
  }

  return null;
};

export const ListItemBullet = styled.div<{ color?: string; background?: string }>`
  --size: 24px;
  color: ${({ color }) => color ?? " #3077EB"};
  font-size: 12px;
  font-weight: 900;
  background: ${({ background }) => background ?? " #F4F7FB"};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
`;

interface AppListTitleProps {
  indented?: boolean;
}

export function AppListTitle(props: PropsWithChildren<AppListTitleProps>) {
  return (
    <h3 className="AppListTitle" data-indented={props.indented === true}>
      {props.children}
    </h3>
  );
}

export function AppListDivider() {
  return <div className="AppListDivider" />;
}
